import { render, staticRenderFns } from "./LegalTariff.vue?vue&type=template&id=85454b3c&scoped=true"
import script from "./LegalTariff.vue?vue&type=script&lang=js"
export * from "./LegalTariff.vue?vue&type=script&lang=js"
import style0 from "./LegalTariff.vue?vue&type=style&index=0&id=85454b3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85454b3c",
  null
  
)

export default component.exports